export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  platformName: '得有店',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 7,
  /***
   *  @description 平台域
   */
  domain: 'deiyoudian.com',
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    //#region 本地开发/测试环境
    // local: '/', // 本地 serve 走 devServer 代理，规避跨域
    // dev: 'http://api.os0.cn',
    // pro: 'http://api.os0.cn',
    //#endregion
    dev: 'http://api-dev.deiyoudian.com',
    pro: 'http://api.deiyoudian.com',
  },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'myshop',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: false, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true, // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    },
  },
  /***
   * 百度统计
   */
  bdStatis: {
    dev: 'a8cba31f36cd73ed08e2f2373c2d3214',
    pro: '4429442fd9552174d6a55c49a8f23e2e',
  },
  pageUrl: [
    {
      type: 1, //优惠券
      h5: '/member/coupon/obtain?id=',
      weapp: 'pages/member/coupon/obtain/index',
      params: '?id=',
    },
    {
      type: 2, //会员卡
      h5: '/member/card-bag/details?type=1&vipcardid=',
      weapp: 'pages/member/card-bag/details/index',
      params: '?type=1&code=',
    },
    {
      //商品推广
      type: 3,
      h5: '/goods/general/',
      weapp: 'pages/goods/general/index',
      params: '?id=',
    },
    {
      //分组管理
      type: 4,
      h5: '/list/',
      weapp: 'pages/list/index',
      params: '?id=',
    },
    {
      //页面管理
      type: 5,
      h5: '/page/',
      weapp: 'pages/page/index',
      params: '?id=',
    },
    {
      //文章推广
      type: 6,
      h5: '/article/',
      weapp: 'pages/article/index/index',
      params: '?id=',
    },
    {
      //分销-招募计划
      type: 7,
      h5: '/salesman/apply',
      weapp: 'pages-salesman/apply/index',
      params: '?id=',
    },
    {
      //分销-海报管理
      type: 8,
      h5: '?invitecode=',
      weapp: 'pages/index/index',
      params: '?invitecode=',
    },
    {
      //拼团
      type: 9,
      h5: '/goods/gorupon/',
      weapp: 'pages/goods/gorupon/index',
      params: '?id=',
    },
    {
      //秒杀推广
      type: 10,
      h5: '/goods/seckill/',
      weapp: 'pages/goods/seckill/index',
      params: '?id=',
    },
    {
      //砍价推广
      type: 11,
      h5: '/goods/bargain/',
      weapp: 'pages/goods/bargain/index',
      params: '?id=',
    },
    // { //招募计划
    //   type: 11,
    //   h5: '/goods/seckill/',
    //   weapp: 'pages/goods/seckill/index',
    //   params:'?id='
    // },
    {
      //满减送推广
      type: 12,
      h5: '/marketing/meetreduce',
      weapp: 'pages/marketing/meetreduce/index',
      params: '?record_id=',
    },
  ],
};
